module.exports = __webpack_public_path__ + "static/media/house-night.0afeb5c5.svg";